// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
// Libs
import { ChartSetSix } from "../Libs/Types/ChartTypes";
// Utils
import {
  CHART_AXIS_FALLBACK,
  chartColors,
  chartHeight,
  humanize,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function GaugeChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetSix["GaugeChart"];
  dataKey: string;
}) {
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      type: "radialBar",
      offsetY: -20,
      sparkline: {
        enabled: true,
      },
      toolbar: {
        show: true,
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          size: "80%",
        },
        track: {
          background: "white",
          strokeWidth: "97%",
          margin: 5, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: "#444",
            opacity: 0.3,
            blur: 10,
          },
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            offsetY: -2,
            fontSize: "20px",
            fontWeight: "bold",
          },
        },
      },
    },
    grid: {
      padding: {
        top: -10,
      },
    },
    fill: {
      type: "gradient",
      colors: chartColors,
      gradient: {
        shade: "light",
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91],
      },
    },
    labels: ["Average Results"],
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
  };

  const series: any =
    chartData !== undefined &&
    Array.isArray(chartData["data"][0]["data"]) === true
      ? chartData["data"][0]["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-6">
      {series !== undefined ? (
        <ApexChart
          type="radialBar"
          options={option}
          series={series}
          height={chartHeight * 2}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
